<script setup>
import { EditableComponent } from "@magnolia/vue-editor";
import PictureElement from "~/templates/elements/PictureElement.vue";
import { mapNodes } from "~/utils/helper/magnolia";
import { DIMENSIONS } from "~/utils/helper/imaging";

const BREAKPOINTS = {
  start: DIMENSIONS["start"].ratio.square,
  md: DIMENSIONS["md"].ratio.square,
};

const BIG_BREAKPOINTS = {
  start: DIMENSIONS["start"].ratio["2/1"],
  md: DIMENSIONS["md"].ratio["2/1"],
};

defineProps(["images"]);
</script>

<template>
  <EditableComponent :content="images" />
  <div class="gap-auto grid grid-cols-2 gap-5 md:grid-cols-3">
    <PictureElement
      v-for="(image, index) in mapNodes(images)"
      :key="index"
      :breakpoints="index % 3 === 0 ? BIG_BREAKPOINTS : BREAKPOINTS"
      :img="image.image"
      :object-position-x="image.image.focusHorizontal"
      :object-position-y="image.image.focusVertical"
      :class="[index % 3 === 0 ? 'col-span-2 aspect-2/1' : 'aspect-square place-self-stretch']"
      img-class="rounded-md h-full w-full object-cover inset-0"
    ></PictureElement>
  </div>
</template>
